const setMessage = (text: string, status: string, display: string) => ({
    type: 'SET_MESSAGE',
    text,
    status,
    display
})

export default setMessage